import * as redux from 'redux'
import { thunk } from 'redux-thunk'
import { middleware as requestMiddleware } from './src/requestMiddleware'
import { createMiddleware as queryMiddleware } from './src/queryMiddleware'
// TODO: Group in a `reducers` namespace
import { reducer as addressReducer } from './src/user/address/reducer'
import { reducer as identityReducer } from './src/user/identity/reducer'
import { reducer as messagesReducer } from './src/messages/reducer'
import { reducer as orderReducer } from './src/user/order/reducer'
import { type State } from './src/types'

export function createStore<STATE>(
  reducer: redux.Reducer<STATE>,
  middlewares: redux.Middleware[] = [],
  preloadedState?: DeepPartial<State<STATE>>,
): redux.Store<State<STATE>> {
  return redux.createStore(
    redux.combineReducers({
      application: reducer,
      user: redux.combineReducers({
        address: addressReducer,
        identity: identityReducer,
        order: orderReducer,
      }),
      messages: messagesReducer,
    }),
    preloadedState as any,
    redux.applyMiddleware(queryMiddleware(), thunk, requestMiddleware, ...middlewares),
  )
}

export { Status } from './src/status'
export type { PromiseAction } from './src/requestMiddleware'
export type { QueryAction } from './src/queryMiddleware'
export type { State } from './src/types'

import * as components from './components'
import * as hooks from './hooks'
import * as actions from './actions'

export { components, hooks, actions }

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}
